import { ComputedAnswerItem } from '~/src/store/modules/exam-answer/types';
import { OFetchRequestOptions, useOFetch } from '../../../requests';
import { CustomFetchContext } from '../../../requests/types';
import { ApiResponse } from '../../../types';
import {
  UserWrongListResponse,
  UserWrongReportResponse,
  UserWrongDetailResponse,
  UserWrongProgressResponse,
} from './types';

// 获取错题列表
export const fetchUserWrongList = async (
  query: {
    highFrequency: number; // 1 高频错题, 0 全部
    startCreateTime?: string; //录入时间开始时间戳
    endCreateTime?: string; //录入时间结束时间戳
    userSubject: string; //末级科目id
    pageSize: number; // 分页
    page: number;
  },
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<UserWrongListResponse>> => {
  return await useOFetch<UserWrongListResponse>(
    '/user-wrong/list',
    {
      method: 'GET',
      query,
      ...options,
    },
    fetchContext
  );
};

// 获取错题作答详情
export const fetchUserWrongDetail = async (
  query: {
    highFrequency: number; // 1 高频错题, 0 全部
    startCreateTime?: string; //录入时间开始时间戳
    endCreateTime?: string; //录入时间结束时间戳
    userSubject: string; //末级科目id
    pageSize: number; // 分页
    page: number;
  },
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<UserWrongDetailResponse>> => {
  return await useOFetch<UserWrongDetailResponse>(
    '/user-wrong/detail',
    {
      method: 'GET',
      query,
      ...options,
    },
    fetchContext
  );
};

// 获取开关配置
export const fetchUserWrongAutoRemoveSwitch = async (
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<{ on: number }>> => {
  return await useOFetch<{ on: number }>(
    '/user-wrong/get-auto-remove-switch',
    {
      method: 'GET',
      ...options,
    },
    fetchContext
  );
};

// 自动移除错题开关
export const changeUserWrongAutoRemoveSwitch = async (
  body: {
    type: number;
  },
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<string>> => {
  return await useOFetch<string>(
    '/user-wrong/auto-remove-switch',
    {
      method: 'POST',
      body,
      ...options,
    },
    fetchContext
  );
};

// 删除错题
export const deleteUserWrong = async (
  body: {
    questionIds: string[];
  },
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<string>> => {
  return await useOFetch<string>(
    '/user-wrong/remove-question',
    {
      method: 'POST',
      body,
      ...options,
    },
    fetchContext
  );
};

// 错题提交
export const submitUserWrong = async (
  body: {
    answer: string;
    examTime: number;
  },
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<string>> => {
  return await useOFetch<string>(
    '/user-wrong/submit',
    {
      method: 'POST',
      body,
      ...options,
    },
    fetchContext
  );
};

// 错题报告
export const fetchUserWrongReport = async (
  query: {
    userSubject: string;
  },
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<UserWrongReportResponse>> => {
  return await useOFetch<UserWrongReportResponse>(
    '/user-wrong/report',
    {
      method: 'GET',
      query,
      ...options,
    },
    fetchContext
  );
};

// 保存错题进度
export const saveUserWrongProgress = async (
  body: {
    answer: ComputedAnswerItem[];
    userSubject: string; //末级科目id
  },
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<string>> => {
  return await useOFetch<string>(
    '/user-wrong/save-progress',
    {
      body,
      method: 'POST',
      ...options,
    },
    fetchContext
  );
};

// 获取错题进度
export const getUserWrongProgress = async (
  query: {
    userSubject: string; //末级科目id
  },
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<UserWrongProgressResponse>> => {
  return await useOFetch<UserWrongProgressResponse>(
    '/user-wrong/get-progress',
    {
      query,
      method: 'POST',
      ...options,
    },
    fetchContext
  );
};
